import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import InputBase from '@material-ui/core/InputBase'
import IconButton from '@material-ui/core/IconButton'
import SearchIcon from '../../../images/icons/search.svg'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    border: '1px solid #604f93',
    boxShadow: '0px 0px 0px 0px '
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  iconButton: {
    padding: 10
  }
}))

export default function CustomizedInputBase(props) {
  const classes = useStyles()

  return (
    <Paper component="form" className={classes.root}>
      <InputBase
        className={classes.input}
        placeholder="Search PMP Vocabulary"
        inputProps={{ 'aria-label': 'search pmp vocabulary' }}
        onChange={props.onChange}
        defaultValue={props.value || null}
        autoFocus={true}
      />
      <IconButton className={classes.iconButton} aria-label="search">
        <img src={SearchIcon} alt="search icon" />
      </IconButton>
    </Paper>
  )
}
